<script>
export default {
  computed: {
    student_condition () {
      return this.$store.getters.student_condition
    }
  },
  data () {
    return {
    }
  },
  methods: {
    getStudent_condition (id) {
      this.$store.dispatch('getStudent_condition', id)
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getStudent_condition(to.params.id)
    })
  },
  mounted () {
  },
  route: {
  }
}
</script>



// WEBPACK FOOTER //
// Student_condition.vue?2983f526